<div *ngIf="store.trainingModUpdate | async"
     class="training-banner bg-green-600 text-white font-semibold text-center h-[1.25rem] flex items-center justify-center">
  TRAINING MODE ACTIVE
</div>